import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Career from "./pages/Careers";
import Team from "./pages/Team";
import Services from "./pages/Services";
import Software from "./pages/Software";
import SoftwarePublicRouter from "./pages/SoftwarePublicRouter";
import Hardware from "./pages/Hardware";
import SubProducts from "./pages/SubProducts";
import SingleProduct from "./pages/SingleProduct";
// import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Git from "./pages/Git";
import LatestNews from "./pages/LatestNews";
import SignIn from "./authentication/SignIn";
import SignUp from "./authentication/SignUp";
import ForgotPassword from "./authentication/ForgotPassword";
import ResetPassword from "./authentication/ResetPassword";
import SubscriberProfile from "./admin/pages/SubscriberProfile";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminRoutes from "./admin/routes/AdminRoutes";
import ShoppingCart from "./pages/ShoppingCart";
import SubscriberSupportTickets from "./pages/support/SubscriberSupportTickets";
import CreateSupportTicket from "./pages/support/CreateSupportTicket";
import SubscriberTicketDetail from "./pages/support/SubscriberTicketDetail";
import Checkout from "./pages/Checkout";
import PaymentStatus from "./pages/PaymentStatus";
import Orders from "./pages/Orders";
import OrderStatus from "./pages/OrderStatus";
import SearchResults from "./pages/SearchResults";
import FloatingSoftwareDemo from "./components/FloatingSoftwareDemo";
import FloatingShopNow from "./components/FloatingShopNow";
import MarketPriceAnalysis from "./pages/MarketPriceAnalysis";
import MarketAnalysisPricing from "./pages/MarketAnalysisPricing";

const LayoutWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isAuthRoute =
    ["/signin", "/signup", "/forgot-password"].some((path) =>
      location.pathname.startsWith(path),
    ) || location.pathname.startsWith("/reset-password");

  const formatVisitedPage = () => {
    const path = window.location.pathname;

    if (path.startsWith("/admin")) {
      return null;
    }

    const params = new URLSearchParams(window.location.search);

    if (path === "/") {
      return "/home";
    }

    if (path === "/subproducts") {
      return `/subproducts Id : ${params.get("id") || "-"}`;
    }

    if (path === "/singleproduct") {
      return `/singleproduct Id : ${params.get("id") || "-"}`;
    }

    return path;
  };

  useEffect(() => {
    const storedUser = JSON.parse(
      localStorage.getItem("subscriber_user") || "null",
    );

    if (storedUser?.tokenExpiry && Date.now() > storedUser.tokenExpiry) {
      localStorage.removeItem("subscriber_user");
      window.location.href = "/signin"; // or your route
    }
  }, []);

  useEffect(() => {
    const visitedPage = formatVisitedPage();

    if (!visitedPage) return;

    fetch(`${import.meta.env.VITE_LYRAZONE_BASE_URL}/admin/dashboard/traffic`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        visitedPage,
      }),
    }).catch((error) => {
      console.error("Website traffic tracking failed:", error);
    });
  }, [location.pathname, location.search]);

  return (
    <>
      {!isAdminRoute && !isAuthRoute && <Header />}
      {children}
      {!isAdminRoute && !isAuthRoute && <Footer />}
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <FloatingShopNow />
      <FloatingSoftwareDemo />
      <ScrollToTop />
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/team" element={<Team />} />
          <Route path="/services" element={<Services />} />
          <Route path="/software" element={<Software />} />
          <Route
            path="/market-price-analysis"
            element={<MarketPriceAnalysis />}
          />
          <Route
            path="/market-analysis-pricing"
            element={<MarketAnalysisPricing />}
          />
          <Route path="/hardware" element={<Hardware />} />
          <Route path="/subproducts" element={<SubProducts />} />
          <Route path="/singleproduct" element={<SingleProduct />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/git" element={<Git />} />
          <Route path="/latestnews" element={<LatestNews />} />
          <Route path="/shopping-cart" element={<ShoppingCart />} />
          <Route path="/subscriber-profile" element={<SubscriberProfile />} />
          <Route path="/support" element={<SubscriberSupportTickets />} />
          <Route path="/support/create" element={<CreateSupportTicket />} />
          <Route path="/search" element={<SearchResults />} />
          <Route
            path="/support/tickets/:id"
            element={<SubscriberTicketDetail />}
          />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderStatus />} />
          <Route path="/:softwareSlug" element={<SoftwarePublicRouter />} />

          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin Panel */}
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </LayoutWrapper>
      {/* <Header /> */}
      {/* <Footer /> */}

      {/* <AdminHeader /> */}
    </Router>
  );
};

export default App;
